var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h60v45H0V0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09C",
    d: "M60 38.4 8.6 0H0v6.4L51.6 45H60v-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M29.7 33c-6 0-5.9-5.6-5.9-5.6v-8.7h11.7v8.7s.2 5.6-5.8 5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.8 18.6h11.7v8.8a2.7 2.7 0 0 1 0 .2 6.5 6.5 0 0 1-.6 2.6c-.4.7-1 1.5-1.8 2s-2 .9-3.4.9c-1.5 0-2.7-.4-3.5-1a4.9 4.9 0 0 1-1.7-1.9 6.5 6.5 0 0 1-.7-2.8v-8.8Zm.1.1v8.7a2 2 0 0 0 0 .2 6.5 6.5 0 0 0 .6 2.6c.4.7 1 1.4 1.7 1.9.9.5 2 .9 3.5.9s2.6-.4 3.4-.9c.8-.5 1.3-1.2 1.7-2a6.4 6.4 0 0 0 .6-2.7v-8.7H24Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D81126",
    d: "M29.6 13.2s-1.2-.6-2.4.3c0 0-2.1-.3-2.3 1.7v.3l.1.2.1.3.1.2.1.5.1.4.1.3v.5l.3.2c.1 0 1.6.5 3.8.5a10.8 10.8 0 0 0 4-.6v-.5s.3-.4.2-.5v-.3l.3-.5V16l.2-.2v-.2s.2-.5.1-.7c0-.3-.4-1.4-2-1.1 0 0-1.1-1-2.8-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.6 13.1a1.4 1.4 0 0 0-.2 0l-.5-.2c-.5 0-1.1 0-1.7.5a1.8 1.8 0 0 0-.3 0l-.8.1-.8.5a2 2 0 0 0-.4 1.2 1.7 1.7 0 0 0 0 .3.2.2 0 0 1 0 .2l.1.1v.2a1.6 1.6 0 0 0 0 .1l.2.2v.4a1 1 0 0 0 .2.5.4.4 0 0 1 0 .2 2.7 2.7 0 0 0 0 .2 2.5 2.5 0 0 1 .1.2v.2l.3.1c.1 0 1.6.6 3.8.5 2.1 0 3-.1 3.8-.4a.3.3 0 0 0 .2-.4.8.8 0 0 1 0-.2 2.6 2.6 0 0 0 .3-.5v-.3a2.2 2.2 0 0 0 .3-.7v-.2h.1a1.4 1.4 0 0 0 0-.2l.1-.1a1.4 1.4 0 0 1 0-.1v-.8s0-.4-.4-.7c-.3-.3-.8-.5-1.6-.4l-.1-.1-.6-.3c-.5-.2-1.2-.3-2 0Zm2.8.6-.2-.1-.6-.2c-.5-.2-1.1-.3-2-.1l-.2-.1-.6-.1c-.4 0-1 0-1.6.5a.6.6 0 0 0-.1 0 2.7 2.7 0 0 0-1 0l-.7.5c-.2.3-.4.6-.4 1.1a2.7 2.7 0 0 1 0 .2.4.4 0 0 1 .1.3v.1l.1.1v.4l.1.1v.2l.1.2a1 1 0 0 0 0 .3.6.6 0 0 1 .2.4v.2a2.7 2.7 0 0 1 0 .3l.2.1c.1 0 1.6.5 3.8.5 2.1 0 2.9-.2 3.8-.5a.1.1 0 0 0 0-.1v-.1a.9.9 0 0 1 .1-.2v-.1a2.4 2.4 0 0 0 .3-.4v-.4a2.2 2.2 0 0 0 .2-.5v-.5h.1v-.2l.2-.2a3.9 3.9 0 0 0 0-.3v-.4a1 1 0 0 0-.4-.7c-.3-.3-.7-.5-1.5-.4Zm1.4 3.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M33.8 17c-4.7-1.5-8.4-.1-8.4-.1l.1.2v.6s0 .3.3.3c0 0 3.3-1.3 7.6 0v-.2l.2-.4.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    fillOpacity: 0.9,
    d: "M29.4 24.8h-2s-.3 1.9 1.3 2.4v.2h.4v.2s-.6.5-.1 1.1v.5h.2v.5s-.1 1.7-1.8 2.5v.1H32v-.1a3.1 3.1 0 0 1-1.8-2.5v-.5h.1v-.3h.1v-.2c.5-.6 0-1.1 0-1.1v-.2h.3v-.2c1.5-.5 1.3-2.4 1.3-2.4h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.3 24.8H32a1.9 1.9 0 0 1 0 .3l-.1.7a2 2 0 0 1-1.3 1.5v.1h-.3v.2a1 1 0 0 1 .2.3c0 .2.1.5-.1.8v.3h-.1v.3h-.1v.6l.2.7a3 3 0 0 0 1.5 1.6v.1h-4.5v-.1a3 3 0 0 0 1.7-2.5V29h-.2v-.3a.9.9 0 0 1-.2-.4v-.4a1 1 0 0 1 .3-.3v-.2h-.3v-.1a2 2 0 0 1-1.3-1.5 3 3 0 0 1-.1-1Zm.1 0a2.3 2.3 0 0 0 0 .3l.1.7a2 2 0 0 0 1.2 1.4v.1h.4v.3a.6.6 0 0 0 0 .1l-.2.3v.3l.1.4v.2h.1v.3h.1v.5a1.5 1.5 0 0 1 0 .3l-.2.6c-.3.6-.7 1.2-1.5 1.6h4.3a3.1 3.1 0 0 1-1.7-2.5v-.8h.2v-.2c.2-.3.2-.6.1-.7a1 1 0 0 0-.2-.3v-.4h.3v-.1a2 2 0 0 0 1.3-1.4 3 3 0 0 0 0-1h-4.4Zm3.2 2.4h-2 2Zm0 .2h-1.9 1.9Zm-.4.2h-1.1 1.1Zm.1 1.2H29h1.3Zm0 .1H29h1.1Zm0 .3H29h1.1Zm.6 2.3h-2.5 2.5Zm.7.6h-4 4Zm.2 0h-4.3 4.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M29.7 24.7a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 1 0 0 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.7 22.5a1.3 1.3 0 0 1 2.3 1 1.4 1.4 0 0 1-1.3 1.3 1.3 1.3 0 0 1-1-2.3Zm1 2.2a1.3 1.3 0 1 0-1.3-1.3 1.3 1.3 0 0 0 1.3 1.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M26.6 21h-.8v-1h-.7v.9h-.8v.7h.8v.8h.7v-.8h.8V21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 20h.9v.8h.7v.9H26v.8h-1v-.8h-.9v-.9h.9V20Zm1.6 1h-.8v-1H25v.8h-.8v.7h.8v.8h.7v-.8h.8v-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M35 21h-.7v-1h-.7v.9h-.9v.7h.8v.8h.8v-.8h.8V21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33.5 20h.8v.8h.8v.9h-.8v.8h-.8v-.8h-.8v-.9h.8V20Zm.1.1v.8h-.8v.7h.8v.8h.6v-.8h.8v-.7h-.8v-.8h-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M30.8 19.9H30V19h-.8v.8h-.7v.7h.8v.8h.7v-.8h.8v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.2 19h.8v.8h.9v.8H30v.9h-.8v-.9h-.8v-.8h.8V19Zm.1.1v.8h-.8v.6h.8v.9h.6v-.9h.9V20h-.9v-.8h-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M26.6 24.4h-.8v-.8h-.7v.8h-.8v.7h.8v.8h.7v-.8h.8v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 23.6h.9v.8h.7v.8H26v.8h-1v-.8h-.9v-.8h.9v-.8Zm1.6.9h-.8v-.8H25v.8h-.8v.6h.8v.8h.7V25h.8v-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M35 24.4h-.7v-.8h-.7v.8h-.9v.7h.8v.8h.8v-.8h.8v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33.5 23.6h.8v.8h.8v.8h-.8v.8h-.8v-.8h-.8v-.8h.8v-.8Zm.1 0v.9h-.8v.6h.8v.8h.6V25h.8v-.6h-.8v-.8h-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M26.6 28h-.8v-.8h-.7v.8h-.8v.7h.8v.8h.7v-.8h.8V28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 27.1h.9v.8h.7v.9H26v.8h-1v-.9h-.9V28h.9v-.8Zm1.6 1h-.8v-.9H25v.8h-.8v.6h.8v.9h.7v-.8h.8V28Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M35 28h-.7v-.8h-.7v.8h-.9v.7h.8v.8h.8v-.8h.8V28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33.5 27.1h.8v.8h.8v.9h-.8v.8h-.8v-.9h-.8V28h.8v-.8Zm.1.1v.8h-.8v.6h.8v.9h.6v-.8h.8V28h-.8v-.8h-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M29.7 11.5a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29 10a.8.8 0 1 1 1.2 1.3.8.8 0 0 1-1.1-1.2Zm.6 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M30.4 10.5h-.7v-1h.3v-.2h-.3v-.2h-.2v.2h-.2v.2h.2v1H29v.2h1.5v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M30.4 10.6h-.7v-1h.3v-.3h-.3v-.2h-.2v.2h-.2v.2h.2v1H29v.2h1.5v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.5 9h.3v.3h.2v.2h-.2v1h.6v.2h-1.5v-.2h.6v-1h-.2v-.2h.2V9Zm0 0v.3h-.2v.2h.3v1H29v.2h1.4v-.1h-.7V9.5h.3v-.2h-.3v-.2h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M26.5 12.4h1s-.4.5-.4 1l.2.7c.1.1.2.4.1.6h.2l-.1-.7a1 1 0 0 1-.1-1l.4-.6c.3.2 1 0 1.2 0 .2-.2.3-.4 0-.4-.4 0-1 0-1.4.3 0 0-.2-.3-1.3-.2-1 .2-1.8.6-2 1.6-.1.4.3 1.5.7 1.7V15s-.6-.8-.4-1.5c.2-.7 1-1.2 2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M26.5 12.4h1s-.4.5-.4 1c0 .4.1.5.2.7.1.1.2.4.1.6h.2l-.1-.7a1 1 0 0 1-.1-1l.4-.6c.3.2 1 0 1.2 0 .2-.2.3-.4 0-.4-.4 0-1 0-1.4.3 0 0-.2-.3-1.3-.2-1 .2-1.8.6-2 1.6-.1.4.3 1.4.7 1.7V15s-.6-.8-.4-1.5c.2-.7 1-1.2 2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29 12h.1v.2l-.1.1-.2.1-.3.1h-.8c0 .2-.2.3-.3.5a1 1 0 0 0 .1 1l.1.5a1.7 1.7 0 0 1 0 .2h-.2v-.3l-.1-.3-.2-.6.1-.8a1.6 1.6 0 0 1 .2-.2h-.5a3.6 3.6 0 0 0-.4 0v-.1c-.9 0-1.7.5-2 1.2 0 .3.1.7.3 1a2.7 2.7 0 0 0 .3.5.7.7 0 0 0 0 .3m-.1 0a1.2 1.2 0 0 1 0-.3 2.4 2.4 0 0 1-.3-.5c-.1-.3-.3-.6-.2-1 .3-.8 1.1-1.3 2-1.2a3.7 3.7 0 0 1 .4 0h.5v.1l-.1.3c-.1.2-.2.4-.1.7l.1.6.2.3v.3a1.5 1.5 0 0 0 0-.2V14a1 1 0 0 1-.2-1 1.5 1.5 0 0 1 .5-.6h1l.2-.1v-.1l.1-.1h-.2c-.3-.1-.9 0-1.3.2m-2.6 3-.2-.2a2.5 2.5 0 0 1-.5-1v-.4c.1-.5.4-.8.7-1 .4-.3.8-.5 1.3-.5h1a.7.7 0 0 1 .3 0v.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.5 12.3.3-.1h-.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.1 12.3s-.2 0-.2.2h-.1c.1-.2.3-.3.4-.3h.6a1.2 1.2 0 0 1-.2.1H28Zm.2 0h.3l.1-.1a1 1 0 0 0-.4 0Zm.5-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M32.8 12.5h-1a1.5 1.5 0 0 1 .2 1.6l-.2.7s-.2-.5 0-.7a1 1 0 0 0 .1-1c0-.3-.2-.5-.4-.6-.3.1-1 0-1.2-.1-.2-.2-.3-.3 0-.4.4 0 1 0 1.4.3 0 0 .2-.2 1.3 0 1 0 1.8.5 2 1.4.1.5-.3 1.5-.7 1.7v-.2s.6-.8.4-1.5c-.2-.8-1-1.3-2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M32.8 12.5h-1a1.5 1.5 0 0 1 .2 1.6l-.2.7s-.2-.5 0-.7a1 1 0 0 0 .1-1c0-.3-.2-.5-.4-.6-.4.1-1 0-1.2-.1-.2-.2-.3-.3 0-.4.4 0 1 0 1.4.3 0 0 .2-.2 1.3 0 1 0 1.8.5 2 1.4.1.5-.3 1.5-.7 1.7v-.2s.6-.8.4-1.5c-.2-.8-1-1.2-2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31 12.1a3 3 0 0 0-.6 0h-.2v.1l.1.1.2.1.3.1h.6c.3.1.4.3.5.5a1 1 0 0 1 0 1l-.2.5a1.5 1.5 0 0 0 0 .3h.1v-.4l.1-.3a1.4 1.4 0 0 0 0-1.5h-.1v-.1h.6a3.4 3.4 0 0 1 .3 0c1 0 1.8.4 2 1.1.2.4 0 .8-.1 1.1a2.7 2.7 0 0 1-.3.5 1.2 1.2 0 0 1 0 .2l.2-.3a2.5 2.5 0 0 0 .5-1v-.4c-.1-.4-.4-.8-.7-1a3 3 0 0 0-1.3-.5h-1a.7.7 0 0 0-.3.2 1 1 0 0 0-.7-.3Zm3.2 3a1 1 0 0 0 .1 0l.2-.4c.2-.3.3-.7.2-1-.2-.7-1-1.2-2-1.2a2.3 2.3 0 0 0-.3 0H32a1.5 1.5 0 0 1 .1 1.7l-.1.2v.4h-.2V14a1 1 0 0 0 .2-1l-.4-.5h-1l-.2-.1-.1-.1V12h.8c.3 0 .5 0 .7.2l.2-.1h1c.6 0 1 .2 1.4.4.4.3.6.6.7 1.1v.5a2.5 2.5 0 0 1-.4 1l-.3.3a1.8 1.8 0 0 0 0-.3h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.8 12.3h-.3.6-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31 12.2c.2 0 .4.2.5.3v.1m0 0-.3-.2v-.1h-.6.7-.7v-.1h.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M29.1 11.8v2.3c0 .2.3.5.5.6 0 0 .5-.2.5-.6v-2.4H30v2c0 .3-.2.6-.4.7 0 0-.3 0-.4-.6v-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M29.1 11.8v2.3c0 .2.3.5.5.6 0 0 .5-.2.5-.6v-2.4H30v2c0 .2 0 .6-.3.7 0 0-.3 0-.4-.7v-2 .1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30 11.7h.2V14c0 .2-.2.4-.3.5a1 1 0 0 1-.3.1 1 1 0 0 1-.4-.3l-.1-.3v-2.3h.2v2c0 .2 0 .4.2.5a.4.4 0 0 0 .1 0h.1l.1-.2.1-.4v-2Zm-.4 2.7h-.2l-.2-.7v-1.9 2.6l.4.2a.8.8 0 0 0 .2 0c.1-.2.3-.3.3-.5v-2.4H30v2a1 1 0 0 1-.2.6l-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.2 14.9a.3.3 0 0 0 .3-.2.3.3 0 1 0-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.2 14.3a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .1a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 14.3a.3.3 0 0 0 .3-.4.3.3 0 1 0-.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 13.7a.3.3 0 0 1 .4.4.3.3 0 1 1-.4-.4Zm.1 0a.2.2 0 0 0-.3.3.2.2 0 1 0 .3-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 13.5a.3.3 0 1 0 .2-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 13a.3.3 0 0 1 .4.4.3.3 0 1 1-.3-.5Zm.2 0a.2.2 0 0 0-.2.1.2.2 0 1 0 .2 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.5 12.9a.3.3 0 0 0 .3-.4.3.3 0 0 0-.3-.1.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.5 12.3a.3.3 0 0 1 .4.5.3.3 0 1 1-.4-.5Zm.1.1a.2.2 0 0 0-.3.2.2.2 0 1 0 .3-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 12.4a.3.3 0 1 0 .1-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 11.9a.3.3 0 0 1 .3.4.3.3 0 1 1-.3-.4Zm.1 0a.2.2 0 1 0-.1.5.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.6 12.2a.3.3 0 0 0 .4-.3.3.3 0 1 0-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.6 11.6a.3.3 0 1 1 .2.7.3.3 0 0 1-.2-.7Zm.1.1a.2.2 0 0 0-.2.4.2.2 0 1 0 .2-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.3 12a.3.3 0 0 0 0-.5.3.3 0 0 0 0 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.3 11.5a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .1a.2.2 0 0 0-.1.4h.1a.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 12a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.7 11.6a.3.3 0 1 1 .5.4.3.3 0 0 1-.5-.4Zm.2 0a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.5 12a.3.3 0 1 0 0-.4.3.3 0 1 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.5 11.5a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .5a.2.2 0 0 1 0-.4.2.2 0 0 1 .3.3.2.2 0 0 1-.3.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.1 11.9a.3.3 0 1 0 .1-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29 11.3a.3.3 0 1 1 .2.6.3.3 0 0 1-.1-.6Zm.2.1a.2.2 0 1 0-.1.4.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 12a.3.3 0 1 0 .2-.5.3.3 0 0 0-.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.6 11.5a.3.3 0 0 1 .4.4.3.3 0 1 1-.4-.4Zm.1 0a.2.2 0 0 0-.2.4.2.2 0 1 0 .2-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 14a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.4 13.5a.3.3 0 1 1 .4.5.3.3 0 0 1-.4-.5Zm.2 0a.2.2 0 0 0-.1.4.2.2 0 1 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.1 15a.3.3 0 1 0 .1-.5.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.1 14.5a.3.3 0 1 1 .1.6.3.3 0 0 1 0-.6Zm.1 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.3 14.4a.3.3 0 0 0 .3-.2.3.3 0 0 0-.3-.3.3.3 0 0 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.3 13.8a.3.3 0 0 1 0 .6.3.3 0 0 1 0-.6Zm0 .1a.2.2 0 0 0-.1.4h.1a.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.2 13.7a.3.3 0 0 0 .3-.4.3.3 0 0 0-.3-.1.3.3 0 0 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.2 13.1a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .1a.2.2 0 0 0-.2.4.2.2 0 1 0 .3-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.9 13a.3.3 0 0 0 .3-.1.3.3 0 1 0-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34.6 12.5a.3.3 0 1 1 .5.5.3.3 0 0 1-.5-.5Zm.3 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.4 12.6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34.4 12a.3.3 0 0 1 0 .6.3.3 0 0 1 0-.6Zm0 .1a.2.2 0 0 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.8 12.3a.3.3 0 1 0 .1-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33.8 11.7a.3.3 0 0 1 .3.5.3.3 0 1 1-.3-.5Zm.1.1a.2.2 0 0 0-.3.2.2.2 0 1 0 .3-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.1 12.1a.3.3 0 0 0 .3-.3.3.3 0 0 0-.3-.2.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33.1 11.6a.3.3 0 0 1 .4.4.3.3 0 1 1-.4-.4Zm.1 0a.2.2 0 0 0-.2.4.2.2 0 1 0 .2-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.5 12a.3.3 0 1 0 .1-.4.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.5 11.5a.3.3 0 0 1 .3.5.3.3 0 1 1-.3-.5Zm.1.1a.2.2 0 1 0-.1.4.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 12a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.7 11.5a.3.3 0 1 1 .5.5.3.3 0 0 1-.5-.5Zm.2 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.3 14.2a.3.3 0 0 0 .3-.2.3.3 0 0 0-.3-.3.3.3 0 1 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.3 13.6a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .5a.2.2 0 0 1 0-.4.2.2 0 0 1 .3.3.2.2 0 0 1-.3.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.4 13.7a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.4 13.1a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .1a.2.2 0 0 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.2 12a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30 11.5a.3.3 0 1 1 .4.4.3.3 0 0 1-.4-.4Zm.2 0a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.9 12a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.9 11.3a.3.3 0 0 1 .3.5.3.3 0 1 1-.3-.5Zm.1.1a.2.2 0 1 0-.1.4.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.6 11.9a.3.3 0 1 0 .1-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.6 11.3a.3.3 0 0 1 .3.5.3.3 0 1 1-.3-.5Zm0 .1a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.9 14.2a.3.3 0 0 0 .3-.1.3.3 0 1 0-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.9 13.6a.3.3 0 1 1 0 .7.3.3 0 0 1 0-.7Zm0 .1a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.8 13.6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.6 13a.3.3 0 1 1 .4.5.3.3 0 0 1-.4-.4Zm.2 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 13a.3.3 0 1 0 .1-.6.3.3 0 0 0-.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27 12.4a.3.3 0 0 1 .3.4.3.3 0 1 1-.3-.4Zm.1 0a.2.2 0 1 0-.1.5.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.2 12a.3.3 0 0 0 .3-.2.3.3 0 1 0-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.2 11.4a.3.3 0 0 1 .3.1.3.3 0 1 1-.3-.1Zm0 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.7 12.1a.3.3 0 0 0 .3-.1.3.3 0 1 0-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.7 11.6a.3.3 0 0 1 .4.4.3.3 0 1 1-.4-.4Zm.1 0a.2.2 0 0 0-.2.4.2.2 0 1 0 .2-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 12.5a.3.3 0 1 0 .1-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.3 12a.3.3 0 0 1 .3.4.3.3 0 0 1-.5 0 .3.3 0 0 1 .2-.5Zm.1 0a.2.2 0 1 0-.1.4.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 12.3a.3.3 0 0 0 .3-.4.3.3 0 0 0-.3-.1.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.6 11.8a.3.3 0 1 1 .1.6.3.3 0 0 1 0-.6Zm.1 0a.2.2 0 0 0-.2.4.2.2 0 1 0 .2-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 12.8a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.4 12.3a.3.3 0 1 1 .4.5.3.3 0 0 1-.4-.5Zm.2 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 13.4a.3.3 0 0 0 .3-.2.3.3 0 1 0-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.4 12.9a.3.3 0 1 1 .4.4.3.3 0 0 1-.4-.4Zm.2 0a.2.2 0 1 0 0 .4.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.5 12a.3.3 0 1 0 0-.6.3.3 0 1 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.3 11.4a.3.3 0 1 1 .5.5.3.3 0 0 1-.5-.5Zm.2 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.9 11.8a.3.3 0 1 0 .1-.5.3.3 0 0 0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.9 11.3a.3.3 0 1 1 .1.6.3.3 0 0 1-.1-.6Zm.1 0a.2.2 0 1 0-.1.5.2.2 0 0 0 .1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.3 11.9a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.3 11.3a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6Zm0 .5a.2.2 0 0 1 0-.4.2.2 0 1 1 0 .4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.3 13a.3.3 0 1 0 .2-.5.3.3 0 0 0-.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.3 12.5a.3.3 0 1 1 .2.6.3.3 0 0 1-.2-.6Zm.2 0a.2.2 0 1 0-.2.5.2.2 0 0 0 .2-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.7 12.1a.3.3 0 0 0 .3-.3.3.3 0 1 0-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.5 11.6a.3.3 0 1 1 .5.5.3.3 0 0 1-.5-.5Zm.2 0a.2.2 0 1 0 0 .5.2.2 0 0 0 0-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.1 12.5a.3.3 0 0 0 .3-.1.3.3 0 1 0-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.1 12a.3.3 0 0 1 .4.4.3.3 0 1 1-.4-.5Zm.1 0a.2.2 0 0 0-.3.2.2.2 0 1 0 .3-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.6 16.5-.7.4.6.4.8-.4-.7-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m29.6 16.5.7.4-.8.4-.7-.4.8-.4Zm0 0-.6.4.5.3.7-.3-.6-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28 16.6-1 .1v.7l1.1-.1v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m28 16.5.1.3a1.8 1.8 0 0 1 0 .4v.1l-1 .2-.1-.2a3.9 3.9 0 0 1 0-.5l1-.3Zm-1 .3a5 5 0 0 0 0 .6l1.1-.1a2.9 2.9 0 0 0 0-.5v-.2l-1 .2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    fillOpacity: 0.9,
    d: "M28 16.8h-1v.5l.9-.1v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28 16.7v.5a10 10 0 0 0-.8.1V17h.1a6.1 6.1 0 0 1 .6-.1Zm0 .1a53 53 0 0 0-.8.1v.3a14.8 14.8 0 0 1 .7 0v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m31 16.6 1.1.2v.7l-1-.2v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m31 16.6 1.2.1a7.7 7.7 0 0 1 0 .8l-1.2-.2a2.9 2.9 0 0 1 0-.5v-.2Zm0 0v.2a1.8 1.8 0 0 0 0 .5l1 .1v-.1a4 4 0 0 0 .1-.5l-1-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    fillOpacity: 0.9,
    d: "m31.2 16.8.8.1v.4h-.8v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.2 16.8a16.4 16.4 0 0 1 .8.1v.4h-.1a12.4 12.4 0 0 0-.7 0v-.5Zm0 0v.4a9.8 9.8 0 0 1 .8 0V17h-.2a6 6 0 0 0-.5 0Zm-5.8.3a3.2 3.2 0 0 1 .2-.1l.5-.1c.4-.1 1-.3 1.8-.3a14.8 14.8 0 0 0-2.2.5l.7.1-.5.5a9.4 9.4 0 0 1 2-.4 13.7 13.7 0 0 0-2.3.5 4.2 4.2 0 0 1 .2 0l.5-.6-.7-.2a5 5 0 0 0-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m25.6 17.7.4-.4h-.5.1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m33.8 17.1-.8.2.5.6-.6-.6.9-.2Zm-8.3.1.6.1-.5.4v-.4l-.1-.1Zm.1 0v.4l.4-.3h-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m33.5 17.7-.3-.3h.5-.2v.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.5 16.7h.2v.1h-.3v-.1Zm0 0v.1h.2l-.1-.1Zm2 0h.2v.2l-.2-.1Zm.1 0v.1h.1v-.1Zm-4.2.3.1-.1h.1v.2l-.2-.1Zm.1 0h.1-.2.1Zm2 0h.2v.2h-.1l-.2-.1Zm0 .2.2-.1h-.2Zm2-.2h.2v.2h-.2V17Zm0 .2h.1l.1-.1h-.2Zm2 0 .1-.2.2.1c0 .1 0 .2-.2.2l-.1-.2Zm.1-.1v.1h.1V17Zm-6.1.3.1-.1h.1v.2h-.2Zm0 0h.2-.2Zm6 0 .1-.1h.1v.2h-.2Zm0 0h.1-.1Zm.8 0 .2.3v-.3h-.2Zm.4 0h-.1v.4l-.4-.3h.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M25.4 16s0 .7.4.6c.5 0 .5-.7.5-.7s.1.5.6.5c.4-.1.4-.8.4-1 0 0 .2.9.7.7.5 0 .5-.6.5-.6s.1.6.5.5c.4 0 .5-.1.5-.7h.2s0 .8.4.8c.5 0 .5-.5.5-.5h.1s0 .5.5.5c.4 0 .4-.4.4-.6h.4s-.4.7.2.8c.6.1.6-.4.6-.4h.2s0 .7.3.7.5 0 .5-.6h.2s-.1 1-.7.8c-.4-.1-.5-.5-.5-.6 0 0-.2.4-.7.3-.4-.1-.4-.5-.4-.6 0 0-.2.5-.6.4-.4 0-.5-.2-.5-.4 0 0-.2.4-.5.3-.3 0-.5-.2-.5-.4 0 0 0 .4-.5.4-.3 0-.5-.1-.6-.3 0 0 0 .4-.5.4-.3 0-.5-.1-.6-.4 0 0 0 .5-.5.6-.4 0-.5-.2-.5-.2s-.1.3-.5.4c-.3.1-.5 0-.6-.4v-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M25.4 16s0 .7.4.6c.5 0 .5-.7.5-.7s.1.5.6.5c.4-.1.4-.8.3-1h.1s.2.9.7.7c.5 0 .5-.6.5-.6s.1.6.5.5c.4 0 .5-.1.5-.7h.2s0 .8.4.8c.5 0 .5-.5.5-.5h.1s0 .5.5.5c.4 0 .4-.4.4-.6h.4s-.4.7.2.8c.6.1.6-.4.6-.4h.2s0 .7.3.7.5 0 .5-.6h.2s-.1 1-.8.8c-.3-.1-.4-.5-.4-.6 0 0-.2.4-.7.3-.4-.1-.4-.5-.4-.6 0 0-.2.5-.6.4-.4 0-.5-.2-.5-.4 0 0-.2.4-.5.3-.3 0-.5-.2-.5-.4 0 0 0 .4-.5.4-.3 0-.5-.1-.6-.3 0 0 0 .4-.5.4-.3 0-.5-.1-.6-.4 0 0 0 .5-.5.6-.4 0-.5-.2-.5-.2s-.1.3-.5.4c-.3.1-.5 0-.6-.4v-.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.8 15.3h-.4v.5l-.4.2-.4-.2a1 1 0 0 1 0-.3h-.2v.3c0 .1-.2.3-.4.3h-.3l-.2-.3a1.5 1.5 0 0 1-.1-.4h-.2v.5c0 .2-.1.4-.3.4h-.3l-.1-.2a.8.8 0 0 1 0-.2h-.2a1.5 1.5 0 0 0 0 .1l-.1.2c0 .2-.1.3-.4.4h-.2l-.1-.3a1 1 0 0 1-.1-.3l-.2-.3v.6c0 .2.2.3.3.4.1 0 .3.1.4 0l.4-.2v-.1h.2c0 .1.2.2.4.1.3 0 .4-.1.5-.3v-.1c.1.2.4.3.6.2a.7.7 0 0 0 .5-.3l.2.2h.4a.6.6 0 0 0 .5-.2c0 .1.2.3.5.3l.4-.2.1-.1.1.2.4.2c.2 0 .4 0 .5-.2l.1-.1v.1c0 .1.2.3.4.3h.6l.1-.2v.2l.4.3h.5l.2-.3a1.4 1.4 0 0 0 .2-.4l-.3-.2-.1.6-.4.1-.2-.1v-.3a1.9 1.9 0 0 1 0-.3h-.3a.6.6 0 0 1 0 .2l-.2.2h-.4l-.2-.1v-.3a1.1 1.1 0 0 1 0-.4h.1-.5v.4l-.4.2c-.2 0-.3-.1-.4-.3a.9.9 0 0 1 0-.2h-.2v.2l-.5.2H30l-.1-.4a1.4 1.4 0 0 1 0-.3Zm.9.3-.1.2c0 .2-.2.3-.5.3l-.3-.1v-.3a1.4 1.4 0 0 1-.1-.4h-.2v.7l-.5.2c-.2 0-.3-.2-.4-.3l-.1-.2v.2c0 .1-.2.3-.5.4h-.3l-.2-.3a1.5 1.5 0 0 1-.2-.4v.4c0 .2-.2.5-.4.5h-.3l-.2-.2a.9.9 0 0 1 0-.3 1.6 1.6 0 0 0 0 .1l-.1.2c0 .2-.2.4-.5.4h-.3l-.1-.2a1.1 1.1 0 0 1 0-.4h-.2l.1.3.2.4h.4c.2 0 .3-.2.4-.3a.8.8 0 0 0 0-.1V16l.1.2h.1l.4.2c.2 0 .3-.2.4-.3a.8.8 0 0 0 0-.3h.2c0 .3.3.4.5.4a.6.6 0 0 0 .5-.4v-.1l.2.3.4.1.4-.2a.5.5 0 0 0 0-.2h.1c0 .2.2.4.5.4.2 0 .3 0 .4-.2a.8.8 0 0 0 0-.1h.2v.2l.4.2.4-.1a1 1 0 0 0 .2-.3l.1.3.3.3.5-.1a.7.7 0 0 0 .2-.2v.1l.1.2.4.3h.3l.3-.3a1.4 1.4 0 0 0 .1-.4h-.1c0 .2 0 .3-.2.4-.1.2-.2.2-.4.2l-.2-.2-.1-.3a2 2 0 0 1 0-.3h-.1a.7.7 0 0 1-.1.3l-.2.1c-.1 0-.2.1-.4 0l-.3-.1v-.3a1.2 1.2 0 0 1 0-.4h-.2l-.1.4c0 .1-.2.3-.4.3-.3 0-.4-.2-.4-.3a1 1 0 0 1-.1-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M26.3 16a.2.2 0 1 0 0-.3.2.2 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M26.3 16a.2.2 0 0 0 .2 0 .2.2 0 1 0-.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.3 15.7a.2.2 0 1 1 .1.4.2.2 0 0 1 0-.4Zm.1 0a.1.1 0 0 0-.1 0 .1.1 0 1 0 .1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M28.5 15.7a.2.2 0 0 0 .2 0 .2.2 0 0 0 0-.2.2.2 0 0 0-.1-.2.2.2 0 0 0-.2.1.2.2 0 0 0 .1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M28.5 15.7a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.5 15.3a.2.2 0 0 1 .2.4.2.2 0 0 1-.4-.2.2.2 0 0 1 .2-.2Zm0 0a.1.1 0 1 0 0 .3.1.1 0 0 0 0-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M30.7 15.8a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M30.7 15.7a.2.2 0 1 0 .1-.3.2.2 0 0 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.7 15.4a.2.2 0 0 1 .2.3.2.2 0 1 1-.2-.3Zm.1 0a.1.1 0 0 0-.1.1.1.1 0 1 0 .1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M33 16.1a.2.2 0 0 0 0-.3.2.2 0 1 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M33 16a.2.2 0 1 0 0-.2.2.2 0 0 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M33 15.7a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4Zm0 .1a.1.1 0 1 0 0 .3.1.1 0 0 0 0-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M29.5 15.5h-.1l-.4.2v-.3c-.3 0-.3-.2-.3-.2l.4-.1v-.3l.3.2s-.2 0-.2-.5h.2s0-.4.2-.4.2.5.2.5l.2-.1c0 .4-.2.5-.2.5l.4-.2v.3l.4.1s0 .2-.4.2v.3s-.3 0-.3-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M29.5 15.5h-.1l-.4.2v-.3c-.3 0-.3-.2-.3-.2l.4-.1v-.3l.3.2s-.2-.1-.2-.5h.2s0-.4.2-.4.2.5.2.5l.2-.1c0 .4-.2.5-.2.5l.4-.2v.3l.4.1s0 .2-.4.2v.3s-.3 0-.3-.2h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m29.6 14 .2.2v.3a.3.3 0 0 1 .2 0v.3h.2v.3h.3v.2l-.3.2v.3a1.5 1.5 0 0 1-.2 0v-.2h-.7l-.2.1a1.2 1.2 0 0 1-.2 0v-.2a.8.8 0 0 1-.3-.2V15h.4v-.2a.6.6 0 0 1 0-.1h.2v-.3a.3.3 0 0 1 .1 0h.1v-.2l.2-.1Zm-.1.6a.2.2 0 0 0-.2 0v.3a1 1 0 0 1 .2.1h-.2l-.3-.2.1.3m.3 0V15Zm0-.5a1.2 1.2 0 0 1 .1-.4h.2v.2a1.3 1.3 0 0 1 0 .2h.1a.2.2 0 0 1 .2 0l-.1.3a1 1 0 0 0-.1 0v.1h.1l.3-.2v.3H30a1.2 1.2 0 0 1 .2 0h.2v.1c0 .1-.1.2-.3.2v.4H30l-.1-.1-.1-.1h-.6l-.1.1H29a.6.6 0 0 1 0-.1h.1a.8.8 0 0 1-.3-.2v-.1h.1a1.2 1.2 0 0 1 .2 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 15.6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.4 15a.3.3 0 1 1 .4.5.3.3 0 0 1-.4-.5Zm.2 0a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.6 15.4a.2.2 0 1 0 0-.3.2.2 0 0 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.5 15.1a.2.2 0 1 1 .2.3.2.2 0 0 1-.2-.3Zm.1 0a.2.2 0 0 0-.2.2.2.2 0 1 0 .2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M32 15.7c0 .2.4.3.4.3v-.3l.4-.1-.4-.2.2-.3-.5.1s.3 0 .3-.4h-.2v-.5H32c-.2 0-.3.4-.3.4h-.2l.1.5-.3-.4v.3l-.4.1.3.3-.1.3s.3 0 .4-.2h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M32 15.7c0 .2.4.3.4.3v-.3l.4-.1-.4-.2.2-.3-.5.1s.3 0 .3-.4h-.2v-.5H32c-.2 0-.3.4-.3.4h-.2l.1.5-.3-.4v.3l-.4.1.3.3-.1.3s.3 0 .4-.2h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32 14.3h.1l.1.1v.4a.3.3 0 0 1 .2 0v.3h.2a.6.6 0 0 1-.1.3h.2l.1.2v.1h-.4v.4a1.2 1.2 0 0 1-.2-.1l-.1-.1v-.1h-.2l-.3-.1h-.2a1.1 1.1 0 0 1-.2.1v-.2a.7.7 0 0 1-.2-.3.1.1 0 0 1 0-.1l.2-.1h.1v-.3l.3.1v-.3a.3.3 0 0 1 .1 0h.1v-.1l.1-.2Zm-.1.4v.1h-.1l-.1-.1a.6.6 0 0 0 0 .3 1 1 0 0 1 0 .1l-.3-.2v.2a1 1 0 0 0-.3 0l-.1.1.3.3v.2h.2v-.1h.4l.2.1v.1l.1.1a1.1 1.1 0 0 0 .1 0 .7.7 0 0 0 0-.1l.4-.2-.1-.1a1 1 0 0 0-.2 0v-.1l.1-.2h-.2a.4.4 0 0 1-.2 0 .9.9 0 0 1 .1 0l.2-.4h-.2m-.1.4Zm-.4 0Zm0 0Zm.2-.5a1.2 1.2 0 0 1 0-.2l.1-.1h.1v.2a1.2 1.2 0 0 1 0 .2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.8 15.8a.3.3 0 0 1-.2-.5.3.3 0 0 1 .3-.2.3.3 0 0 1 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32 15.2a.3.3 0 0 0-.2.5.3.3 0 1 0 .1-.5Zm0 0a.3.3 0 0 0-.4.4.3.3 0 0 0 .2.2.3.3 0 0 0 .1-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.8 15.6a.2.2 0 0 1 0-.3.2.2 0 0 1 .2 0 .2.2 0 0 1-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32 15.3a.2.2 0 1 0-.2.3.2.2 0 0 0 .1-.3Zm-.2 0a.2.2 0 0 1 .2 0 .2.2 0 1 1-.2 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M27.2 15.7h-.1l-.4.3v-.3c-.3 0-.3-.2-.3-.2l.3-.2V15l.4.2s-.3 0-.3-.5h.2l.1-.4c.2 0 .3.4.3.4h.2c0 .3-.2.5-.2.5s.2-.3.4-.3v.3h.4s0 .2-.3.3v.3s-.3 0-.3-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M27.2 15.7h-.1l-.4.3v-.3c-.3 0-.3-.2-.3-.2l.3-.2V15l.4.2s-.3 0-.3-.5h.2l.1-.4c.2 0 .3.4.3.4h.2c0 .3-.2.5-.2.5s.2-.3.4-.3v.3h.4s0 .2-.3.3v.3s-.3 0-.3-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.1 14.2.2.1v.2l.1.1a.3.3 0 0 1 .2 0v.3h.2v.2h.4l.1.1v.2l-.3.1v.1s.1.1 0 .2a1 1 0 0 1-.1 0h-.2v-.2h-.4v.1l-.2.1v.1a1.2 1.2 0 0 1-.2.1l-.1-.2v-.1l-.3-.1v-.2h.2V15h.2v-.3h.2v-.3l.1-.2Zm0 .6h-.2v.3a1 1 0 0 1 .2 0v.1h-.2l-.2-.1v.2h.1m.3-.1Zm0 0Zm0-.4a1.4 1.4 0 0 1 0-.3v-.2h.1l.1.2a1.2 1.2 0 0 1 0 .2m-.9.8.4.1a.6.6 0 0 0 0 .3l.2-.1v-.1h.2l.2-.1h.2l.2.1h.1v-.2l.2-.2-.1-.1a1 1 0 0 0-.2 0v-.4l-.2.1a.4.4 0 0 1-.1.2.7.7 0 0 1 0-.2v-.3m0 .5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 15.7a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.2 15.1a.3.3 0 1 1 .1.7.3.3 0 0 1 0-.7Zm.2 0a.3.3 0 0 0-.4.4.3.3 0 1 0 .4-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 15.6a.2.2 0 1 0 0-.3.2.2 0 0 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.3 15.3a.2.2 0 0 1 .2 0 .2.2 0 1 1-.2 0Zm0 0a.2.2 0 0 0-.1.1.2.2 0 0 0 .2.1.2.2 0 0 0 0-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M34 16.3s0-.2-.2-.1h-.3V16s-.2 0-.3-.3c0 0 .1-.1.4 0v-.3s.4 0 .4.3V15s.2 0 .2.2c0 0 0-.3.5-.3l-.2.4-.3.3v.2l-.1.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M34 16.3s0-.2-.2-.1h-.3V16s-.3 0-.3-.3c0 0 .1-.1.4 0v-.3s.4 0 .4.3V15s.2 0 .2.2c0 0 0-.3.5-.3l-.2.4-.3.3v.2l-.1.2v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34.2 15.3V15H34l-.1.4a1 1 0 0 0 0 .2v-.1l-.2-.1a.8.8 0 0 0-.1 0 .8.8 0 0 0 0 .1h-.4v.5a.6.6 0 0 0 .2 0v.3h.5V16l.1-.1.1-.1v-.1a2 2 0 0 1 .1-.2h.1v-.2a1.1 1.1 0 0 1 .3-.2h-.4a.3.3 0 0 0 0 .2Zm.6-.2a1.6 1.6 0 0 0-.2.2l-.1.2h-.1a1.9 1.9 0 0 0-.1.2v.1l-.1.1v.3l-.2.1-.1-.1h-.2l-.2.1a.5.5 0 0 1 0-.2l-.2-.1-.1-.3v-.1h.4v-.2a1 1 0 0 1 .2 0l.1.1.1-.5h.1l.1.2c.2-.2.3-.2.5-.2h.1Zm-1.6.6Zm1-.4Zm-.2 1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.8 16a.3.3 0 0 1 .4-.3v.2l-.1.2v.2a.3.3 0 0 1-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34.1 15.7a.3.3 0 0 0-.3.2.3.3 0 0 0 .1.3h.1V16l.2-.2a.3.3 0 0 0 0-.2Zm-.3.2a.3.3 0 0 1 .5-.2v.1l-.1.1v.2l-.1.2a.3.3 0 0 1-.3-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.9 16a.2.2 0 0 1 .3-.1l-.1.2c-.2 0-.2 0-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M34.1 15.8a.2.2 0 0 0-.2 0v.4h.2V16Zm-.2.2a.2.2 0 0 1 .2-.2h.1v.4H34l-.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M25.2 16.2s.1-.2.3 0h.3V16l.3-.3s-.2-.2-.5-.1v-.3s-.3.1-.3.3V15s-.2 0-.2.2c0 0 0-.3-.5-.3l.2.4.2.3v.2c.2 0 .2.2.1.2l.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCAC0B",
    d: "M25.2 16.2s.1-.2.3-.1l.3.1V16l.3-.3s-.1-.2-.5-.1v-.3s-.3.1-.3.3V15s-.2 0-.2.2c0 0 0-.3-.5-.3l.2.4.2.3v.2c.2 0 .2.2.1.2l.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25 15h.1a.3.3 0 0 1 .1 0 .7.7 0 0 1 .2.4.9.9 0 0 1 .2-.1.5.5 0 0 1 0 .2h.4a.4.4 0 0 1 0 .1h.1c0 .2-.1.3-.2.3v.2a.7.7 0 0 1 0 .1h-.5a.2.2 0 0 0-.1 0h-.1L25 16v-.4l-.1-.1v-.1l-.1-.1v-.1a1 1 0 0 0-.2-.2v-.1l.4.1Zm-.3 0a2 2 0 0 1 .1.1v.2l.1.1.1.1v.2h.1v.4h.6V16a.4.4 0 0 0 .2-.1l.1-.2-.4-.1a.7.7 0 0 0 0-.2.7.7 0 0 0-.2.1v.1h-.1V15h-.1v.2H25a.3.3 0 0 0 0-.1c0-.1-.2-.2-.3-.1Zm.3.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.5 15.8a.3.3 0 0 0-.5-.2v.2c.2 0 .2.2.1.2v.2h.1a.3.3 0 0 0 .3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.2 15.6a.3.3 0 0 1 .2.5.3.3 0 0 1-.2.1V16l-.1-.2-.1-.2h.2Zm.1 0a.3.3 0 0 0-.3 0l.1.2v.4h.1a.3.3 0 0 0 .2-.5h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.3 15.9a.2.2 0 0 0-.3-.1c.2 0 .2.2.1.2h.1c.1 0 .2 0 .1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.1 15.7a.2.2 0 0 1 .3.2l-.2.1-.1-.2v-.1Zm.2.2a.2.2 0 0 0 0-.2.2.2 0 0 0-.2 0v.3h.1l.1-.1Zm.4 2.2V18a1.6 1.6 0 0 1 .2 0l.4-.2 1.6-.3a13 13 0 0 1 5.5.5v.2a12.9 12.9 0 0 0-7.6 0Zm2.1-1.7a14.5 14.5 0 0 0-2.4.6v-.1a5.5 5.5 0 0 1 .6-.2l1.8-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m29.6 16.7-.4.2.4.2.4-.2-.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m29.6 16.7.4.2-.4.2-.4-.2.4-.2Zm0 0-.3.2.3.1.3-.1-.3-.2Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGl);
export default __webpack_public_path__ + "static/media/gl.39b65fcd6d9fae3b648353b591ef37d6.svg";
export { ForwardRef as ReactComponent };